import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewCreditCardDialogStep } from '../../../credit-card/models/new-credit-card-dialog-result.enum';

@Component({
standalone: false,
  selector: 'app-new-credit-card-dialog',
  styleUrls: ['./new-credit-card-dialog.component.scss'],
  templateUrl: './new-credit-card-dialog.component.html',
})
export class NewCreditCardDialogComponent implements OnInit {
  step: NewCreditCardDialogStep;
  fromPayment: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {}

  public ngOnInit(): void {
    this.step = this.data.step;
    this.fromPayment = this.data.returnUrl?.includes('pay');
  }
}
